const OK_BUTTON_TEXT = 'Ок';
const CANCEL_BUTTON_TEXT = 'Отмена';

export const localText = {
  okButtonLabel: OK_BUTTON_TEXT,
  cancelButtonLabel: CANCEL_BUTTON_TEXT,
};

export const CAPTCHA_CHECK_ERROR = 'Пожалуйста, пройдите проверку';
